import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { App } from './core/App';
import './shared/styles/styles.scss';
var root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(App, {}));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
